export const TilePlaceholder = () => {
  return <section id="tile-placeholder" className="animate-pulse"></section>;
};
